import { render } from "./AddBtn.vue?vue&type=template&id=6c0d315d&scoped=true"
import script from "./AddBtn.vue?vue&type=script&lang=js"
export * from "./AddBtn.vue?vue&type=script&lang=js"

import "./AddBtn.vue?vue&type=style&index=0&id=6c0d315d&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\chandigarh\\kanda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0d315d"]])

export default __exports__